module.exports = new __parcel__URL__("google-drive.d0028a0e.png").toString();